import {createApp} from 'vue'
import App from './App.vue'
import store from './store.js'

const app = createApp(App)
app.use(store)
app.mount('#app')

const place_code = location.pathname.split('/')[3];
if (place_code && place_code.length) {
  store.dispatch('loadData', place_code).then((place) => {
    if (place) {
      document.title = place.name
      window.PageView({page_title: place.name, page_name: location.pathname + location.search, page_location: location.href})
    } else {
      document.title = '店舗登録なし'
      window.PageView({page_title: '店舗登録なし', page_name: location.pathname + location.search, page_location: location.href})
    }
  });
}
